// IE対応
import 'es6-promise/auto'
import axios from 'axios'
// TODO: 共通化
import { csrfToken } from 'rails-ujs'
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken()

export default class Organization {
  static getOrganizationMembers (organizationId) {
    return axios.get(`/api/organizations/${organizationId}/organization_members.json`)
  }
  static getOrganizationClinicUsers (organizationId, clinicId) {
    return axios.get(`/api/organizations/${organizationId}/organization_members.json`, { params: {clinic_id: clinicId} })
  }
  static getOrganizationMember (id) {
    return axios.get(`/api/organization_members/${id}.json`)
  }
  static deleteOrganizationMember (id) {
    return axios.delete(`/api/organization_members/${id}`)
  }
  static addClinic (organizationId, params) {
    return axios.post(`/api/organizations/${organizationId}/clinics.json`, { clinic: params })
  }
  static addContract (organizationId) {
    return axios.post(`/api/organizations/${organizationId}/contracts`)
  }
  static addMemberContract (organizationMemberId) {
    return axios.post(`/api/organization_members/${organizationMemberId}/contracts`)
  }
}
